/*global google*/
import actionType from "../../../../../../../context/actionType";
import {Marker} from "react-google-maps";
import React, {useContext, useState, Dispatch, SetStateAction} from "react";
import InfoWindow from "react-google-maps/lib/components/InfoWindow";
import {reducer} from "../../../../../../../context";
// import {AssetVariant} from "../../../../../../../interface/Server";
import {Asset} from "../../../../../../../interface/Server";
// import {CarouselWrapper} from "../../../../../Widget/Carousel";
import {MapMarkerText} from "../../../AssetListScreenStyles";

interface Props {
    assetVariant: Asset,
    onPressMarker: (setOpen: boolean) => void,
}

export const MarkerWrapper: React.FunctionComponent<Props> = props => {
    const {googleMapReducer} = useContext(reducer);
    const [open, setOpen] = useState(true);
    const {assetVariant} = props;
    return <Marker
        onClick={
            () => {
                setOpen(!open);
                props.onPressMarker && props.onPressMarker(!open);
                googleMapReducer.dispatch(
                    {
                        type: actionType.googleMap.GOOGLE_EDIT_SELECTED_MARKER,
                        payload: {
                            selectedMarker: assetVariant
                        }
                    }
                )
            }
        }
        // label={{
        //     text: assetVariant.status !== 'OnShelf'
        //         ? `${assetVariant.donorNameInReceipt}`
        //         : `${assetVariant.giftAmountCurrency}${assetVariant.giftAmount.toLocaleString()}`,
        //     color: 'white',
        // }}
        icon={{
            url: `${assetVariant.images && assetVariant.images[0] || ''}`,
            scaledSize: new google.maps.Size(100, 80),
            // url: `/assets/icons/CombinedShape-${assetVariant.purchased ? 'g' : 'b'}.svg`,
            // size: new google.maps.Size(73, 34),
        }}
        position={assetVariant.position}/>
        // position={{
        //     lat: 22.300981,
        //     lng: 114.157282
        // }}>
    //     {/* {(open && googleMapReducer.state.selectedMarker === assetVariant) && 
    //     <InfoWindow
    //         onCloseClick={() => setOpen(!open)}
    //     >
    //     <> 
    //         {assetVariant.image &&
    //             <img 
    //                 style={{
    //                 width: '168px',
    //                 height: '112px',
    //             }}
    //             src={assetVariant.image}/>
    //         }
    //         <MapMarkerText title>
    //             {assetVariant.name}
    //         </MapMarkerText>
    //         <MapMarkerText>
    //             {`Adopt Price: HK$${assetVariant.price}`}
    //         </MapMarkerText>
    //     </>
    //     </InfoWindow>} */}
    // </Marker>


};
